/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom"
import Breadcrumb from "./Breadcrumb";
import Card from "./Card";
import FormInput from "./FormInput";
import LoadingAlert from "./LoadingAlert";
import withParams from "./WithParams";
import { qreq } from "../shared/qrequest";
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import Globals from "../shared/Globals";
import Address from "./Address";
import { SidebarGlobal } from "./_SidebarGlobal";
import MessageDialog from "./MessageDialog";

class MedicalProcedureView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            item: {
                address: {}
            }
        };
        if (this.props.params.id) {
            this.id = this.props.params.id;
            this.state.loading = true;
        }

        this.submit = this.submit.bind(this);
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    load() {
        if (this.id) {
            qreq.get('/api/medical-procedure/get/' + this.id, j => {
                if (j.errorCode)
                    alert(j.errorMessage);
                else {
                    this.state.item = j.item;
                    this.setState({ item: this.state.item });
                }
                this.setState({ loading: false });
            }, e => {
                this.goBack();
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {

    }

    submit(e) {
        if (e)
            e.preventDefault();

        var item = { ...this.state.item };


        this.setState({ saving: true });


        qreq.post('/api/medical-procedure/save', item, (j) => {
            if (j.errorCode !== 0)
                alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        });
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Medical Procedures</L></h1><LoadingAlert /></div>);
        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-success" onClick={() => document.getElementById('c-submit').click()}><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button></>);

        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1><L>Medical Procedures</L></h1>
                <Breadcrumb path={[['Medical Procedures', '/medical-procedure/list'], [this.id ? 'Edit' : 'New']]} />
                <Card title="Procedure Info">
                    <FormInput model={this.state.item} name="name" label="Procedure Name" type="text" required />
                </Card>
                {this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>

                    <div className="d-none">
                        <button id="c-submit" type="submit" className="btn btn-success d-inline-block"><L>Save</L></button>
                        <button type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}><L>Cancel and Go Back</L></button>
                    </div></>)}
            </form>
        </div>;
    }
}

export default withParams(MedicalProcedureView);